import BasePage from "./subBasePage";

export default class Page2Sub3 extends BasePage{
    constructor(info){
        super(info);
        super.set();

        this.ele = info.ele;
        this.pageTl = new TimelineMax({ paused: true, ease: Power2.easeOut });
        this._pageSet();
        this._bindEvent();

        this.player1 = new nc.promokit.Player({
            selector: '#sec2-sub3-player',
            videoId: 'https://vod.plaync.com/BS/old/190612_archery/archer3_skill_bg.mp4',
            mute: true,
            controls: false,
            coverClick: false,
            loop: true
        });
    }

    _pageSet(){
        this.pageTl
            .fromTo( this.ele.querySelector('.tit strong em'), 1, { y: 90, autoAlpha: 0 }, { y: 0, autoAlpha: 1, delay: 0.1, ease: Back.easeOut.config(1.05) })
            .fromTo( this.ele.querySelector('.tit span em'), 1, { y: 90, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Back.easeOut.config(1.05) }, "-=0.7")

            .addLabel('mo1', '-=0.3')
            .fromTo( this.ele.querySelector('.txt-1'), 1, { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, 'mo1')
            .fromTo( this.ele.querySelector('.list'), 0.5, { y: 60, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, "-=0.6")
            .fromTo( this.ele.querySelector('.char-3 .bg'), 0.45, { rotation: 0, opacity: 0, scale: 0.4 },{ opacity: 1, scale: 1, rotation: 360, ease: Back.easeOut.config(1.7) }, "-=0")
            .call(()=>{ $( this.ele ).find('.char-3').addClass('on') }, null, null, '-=0.45')

            .fromTo( this.ele.querySelector('.bg-box .char'), 1, { x: 20, y: -80, autoAlpha: 0 }, { x: 0, y: 0, autoAlpha: 1, ease: Power2.easeOut }, "mo1")
            .fromTo( this.ele.querySelector('.bg-box .bg'), 0.5, { autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1, ease: Power4.easeIn }, "-=0.8")
            .fromTo( this.ele.querySelector('.bg-box .bg-2'), 0.5, { y: 60, x: -20, scale: 1.7, autoAlpha: 0 }, { y: 0, x: 0, scale: 1, autoAlpha: 1, ease: Back.easeOut }, "-=0.47")
    }

    _pageMotion(){
        this.player1.seek(0);
        this.player1.play();
        this.pageTl.restart();
    }

    _hide(){
        this.player1.pause();
        setTimeout(()=>{
            this.pageTl.reverse();
        }, 500)
    }

    _bindEvent(){
        this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );
        this.ele.addEventListener('hideComplete', this._hide.bind(this) );
    }

    show(){
        super.show();
    }
}


// WEBPACK FOOTER //
// ./src/js/subDeath/page2_sub3.js